import { useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";
import { IDropdownOption } from "components/atoms";
import { SurveyApi, surveyApi } from "api/surveyApi";
import { QUERIES_KEYS } from "queries";

export const useSurveys = (
  skip: number,
  limit: number,
  searchPhrase: string = "",
  filter: string = "",
  orderBy: string = "",
) => {
  const queryClient = useQueryClient();
  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.SURVEYS(skip, limit, searchPhrase, filter, orderBy),
    queryFn: () => surveyApi.fetch(skip, limit, searchPhrase, filter, orderBy),
    placeholderData: keepPreviousData,
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.SURVEYS(skip, limit, searchPhrase, filter, orderBy),
    });
  };

  return { invalidate, isLoading, isFetching, surveys: data?.data.data ?? [], total: data?.data.total ?? 0 };
};
export interface SurveyOption extends IDropdownOption {
  survey?: SurveyApi;
}
export const useSurveysOptions = (filter: string = "") => {
  const { isLoading, surveys } = useSurveys(0, 1_000_000, "", filter);

  const options: SurveyOption[] = surveys.map((x) => ({
    value: x.id.toString(),
    label: x.name,
    survey: x,
  }));

  return { loading: isLoading, options };
};
